"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var typography_1 = require("./typography");
var colors_1 = require("../util/colors");
var Wrapper = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 1rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"], ["\n  background-color: ", ";\n  border-radius: 1rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"])), function (_a) {
    var pillColor = _a.pillColor;
    return pillColor ? pillColor : colors_1.colors.gray50;
});
var Pill = function (_a) {
    var pillColor = _a.pillColor, children = _a.children, rest = __rest(_a, ["pillColor", "children"]);
    return (react_1.default.createElement(Wrapper, { pillColor: pillColor },
        react_1.default.createElement(typography_1.Text, __assign({ py: 0.75, px: 1.5 }, rest), children)));
};
exports.default = Pill;
var templateObject_1;
//# sourceMappingURL=Pill.js.map